module.exports = __webpack_public_path__ + "fonts/druk-wide.aaf59e9.ttf";